/**
 * Cart checkout: strip unavailable lines, then go — no 1.5s theater.
 * Event delegation survives Ajax cart drawer re-renders.
 * Panam Walk windbreakers stay in cart (chapter open).
 */
(function () {
  var validating = false;

  function cartIsEmpty() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return true;
    if (drawer.classList.contains('is-empty')) return true;
    var btn = document.getElementById('CartDrawer-Checkout');
    if (btn && btn.disabled) return true;
    return false;
  }

  function changeLine(line, quantity) {
    return fetch((window.routes && routes.cart_change_url) || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: quantity }),
    }).then(function (r) {
      return r.json();
    });
  }

  function scrubCart() {
    return fetch((window.routes && routes.cart_url ? routes.cart_url + '.js' : '/cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var chain = Promise.resolve();
        /* Remove from end so line indexes stay valid */
        for (var i = items.length - 1; i >= 0; i--) {
          (function (item, line) {
            if (item.available !== false) return;
            chain = chain.then(function () {
              return changeLine(line, 0);
            });
          })(items[i], i + 1);
        }
        return chain;
      })
      .catch(function () {
        /* Proceed even if scrub fails — better than stuck checkout */
      });
  }

  function goCheckout() {
    var form = document.getElementById('CartDrawer-Form');
    if (form) {
      var existing = form.querySelector('input[name="checkout"][data-ql-validate]');
      if (!existing) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'checkout';
        input.value = '1';
        input.setAttribute('data-ql-validate', '1');
        form.appendChild(input);
      }
      form.submit();
      return;
    }
    window.location.href = '/checkout';
  }

  function onCheckoutIntent(event) {
    var btn =
      event.target &&
      event.target.closest &&
      event.target.closest('#CartDrawer-Checkout, [data-ql-checkout], [data-ql-checkout-theater]');
    if (!btn) return;
    if (cartIsEmpty()) return;
    if (validating) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    validating = true;
    btn.disabled = true;

    scrubCart()
      .then(function () {
        goCheckout();
      })
      .finally(function () {
        /* If navigation fails, unlock so shopper can retry */
        window.setTimeout(function () {
          validating = false;
          if (btn && document.body.contains(btn)) btn.disabled = false;
        }, 4000);
      });
  }

  function purgeBlockedFromCartOnLoad() {
    scrubCart().then(function () {
      /* Silent; drawer refreshes on next open / ATC */
    });
  }

  function init() {
    if (document.documentElement.dataset.qlCartValidateInit === '1') return;
    document.documentElement.dataset.qlCartValidateInit = '1';
    document.addEventListener('click', onCheckoutIntent, true);
    if (document.readyState === 'complete') purgeBlockedFromCartOnLoad();
    else window.addEventListener('load', purgeBlockedFromCartOnLoad, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
